import { __decorate } from "tslib";
import { Component, Vue } from 'vue-property-decorator';
let Search = class Search extends Vue {
    constructor() {
        super(...arguments);
        this.query = '';
        this.sort = true;
    }
    get queryParams() {
        return this.$route.query;
    }
    search() {
        const sortValue = (this.sort) ? '-date' : '';
        if (this.query && this.query.length > 0 && (this.queryParams.q !== this.query || this.queryParams.sort !== sortValue)) {
            this.$router.push({
                name: 'content.search',
                query: {
                    q: this.query,
                    label: 'all',
                    sort: sortValue
                }
            });
        }
        this.$emit('search', this.query);
    }
    addEventListener() {
        if (typeof window === 'undefined' || typeof document === 'undefined') {
            return;
        }
        document.addEventListener('keydown', this.onSearchTrigger);
    }
    onSearchTrigger(event) {
        if (event && event.key !== 'Enter') {
            return;
        }
        if (!this.query) {
            return;
        }
        this.search();
    }
};
Search = __decorate([
    Component({
        name: 'Search',
        created() {
            this.addEventListener();
            if (this.$route.name === 'content.search') {
                if (!!this.$route.query.q && typeof this.$route.query.q === 'string') {
                    this.query = this.$route.query.q;
                }
                if (!!this.$route.query.sort && typeof this.$route.query.sort === 'string') {
                    this.sort = (this.$route.query.sort === '-date');
                }
            }
        },
        beforeDestroy() {
            if (!document) {
                return;
            }
            document.removeEventListener('keydown', this.onSearchTrigger);
        }
    })
], Search);
export { Search };
export default Search;
